<template>
  <div class="gray-box d-block">
    <div class="accordion-block-box d-flex gap-3 align-items-center">
      <img :src="animalIcon" />
      <div class="accordion-block-info w-100">
        <div class="accordion-block-info-top d-flex align-items-center gap-3">
          <p>
            <i class="ti ti-calendar pe-2 blue-color"></i>
            <small>{{ $t("reminder.next_reminder_date", { date: formattedNextReminderDate }) }}  (J-7 avant la fin du sac)</small>
          </p>
        </div>
        <div class="accordion-block-info-bottom mt-3">
          <ul class="d-flex align-items-center gap-2">
            <li>
              <span>{{ $t("reminder.bag_name") }}</span>
              <strong>{{ bagName }}</strong>
            </li>

            <li>
              <span>{{ $t("reminder.ration_per_day") }}</span>
              <strong>{{ rationPerDay }}</strong>
            </li>

            <li>
              <span>{{ $t("reminder.bag_duration") }}</span>
              <strong>{{ bagDuration }}</strong>
            </li>

            <li>
              <span>{{ $t("reminder.notification_types") }}</span>
              <div class="d-flex gap-3 align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="small">E-mail</span>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="hasEmailNotification"
                      disabled
                      style="pointer-events: none"
                    />
                  </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span class="small">SMS</span>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="hasSmsNotification"
                      disabled
                      style="pointer-events: none"
                    />
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="accordion-block-right d-flex align-items-center gap-3">
            <a href="#" class="btn btn-orange btn-circle" @click.prevent="handleEdit">
              <img :src="editIcon" />
            </a>
            <a href="#" class="btn btn-orange btn-circle" @click.prevent="handleDelete">
              <img :src="deleteIcon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import animalIcon from "@/assets/images/animal.png";
  import editIcon from "@/assets/icons/edit.svg";
  import deleteIcon from "@/assets/icons/delete.svg";

  export default {
    name: "RappelAccordion",
    props: {
      reminder: {
        type: Object,
        required: true,
        default: () => ({}),
      },
    },
    data() {
      return {
        animalIcon,
        editIcon,
        deleteIcon,
      };
    },
    computed: {
      animalDisplayName() {
        return this.reminder?.animalTypeName || "Animal";
      },

      formattedNextReminderDate() {
        if (!this.reminder?.nextReminderDate) return "Date non définie";

        try {
          const dateParts = this.reminder.nextReminderDate.split("/");
          if (dateParts.length === 3) {
            const [day, month, year] = dateParts;
            const date = new Date(year, month - 1, day);
            return date.toLocaleDateString("fr-FR", {
              day: "numeric",
              month: "long",
              year: "numeric",
            });
          }
          return this.reminder.nextReminderDate;
        } catch (error) {
          console.warn("Erreur lors du formatage de la date:", error);
          return this.reminder.nextReminderDate;
        }
      },

      bagName() {
        return this.reminder?.nomSac || "Produit non défini";
      },

      rationPerDay() {
        return this.reminder?.rationJour || "-";
      },

      bagDuration() {
        return this.reminder?.dureeSac || "-";
      },

      hasEmailNotification() {
        return this.reminder?.notificationType?.includes("email") || false;
      },

      hasSmsNotification() {
        return this.reminder?.notificationType?.includes("sms") || false;
      },
    },
    methods: {
      handleEdit() {
        this.$emit("edit", this.reminder);
      },

      handleDelete() {
        this.$emit("delete", this.reminder);
      },

      getAnimalTypeLabel(animalTypeId) {
        const animalTypes = {
          1: "Chat",
          2: "Chien",
          3: "Cheval",
          4: "Lapin",
          5: "Oiseau",
        };

        return animalTypes[animalTypeId] || "Type inconnu";
      },
    },
  };
</script>

<style>
  @import "@/assets/css/components/CalculRation.css";

  .badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.375rem;
  }

  .badge i {
    margin-right: 0.25rem;
  }

  .bg-primary {
    background-color: #007bff !important;
    color: white;
  }

  .bg-success {
    background-color: #28a745 !important;
    color: white;
  }
</style>
